import React from 'react';
import { Link } from 'react-router-dom';

import './GamesCard.css'

// One game on the Games page: `game` is an entry from gameList.js
export class GamesCard extends React.Component {

    state = {
        imageFailed: false
    };

    // The game's icon: its picture, or the same character the home page shows for it
    renderIcon(game) {
        if (game.image && !this.state.imageFailed) {
            return <img className={game.pixelArt ? 'is-pixel-art' : ''} src={game.image} alt="" onError={() => this.setState({ imageFailed: true })} />;
        }
        return <span className="games-card-glyph" aria-hidden="true">{game.glyph || game.name.charAt(0)}</span>;
    }

    render() {
        let game = this.props.game;
        return (
            <div className="box-shadow games-card">
                <h3>{game.name}</h3>
                <div className="games-card-image">
                    {this.renderIcon(game)}
                </div>
                <div className="games-card-body">
                    <p className="card-text">{game.description}</p>
                    <div className="games-card-buttons">
                        {game.path ?
                            <Link className="btn rounded games-card-btn" to={game.path}>Play</Link>
                            :
                            // hosted at its own address: opens in a new tab
                            <a className="btn rounded games-card-btn" href={game.url} target="_blank" rel="noopener noreferrer">Play</a>
                        }
                        {game.scores ?
                            <Link className="btn rounded games-card-btn" to={game.scores}>Scores</Link>
                            :
                            <button type="button" className="btn rounded games-card-btn" disabled title="No leaderboard yet">Scores</button>
                        }
                    </div>
                </div>
            </div>
        );
    }

}
